import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col p-4" }
const _hoisted_2 = { class: "text-2xl mb-2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Clinical Summary ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl my-2" }, "Requested Procedures", -1)
const _hoisted_5 = {
  key: 2,
  class: "adjudication-comments p-2 my-4 text-lg w-full border-2 rounded-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmissionInformation = _resolveComponent("SubmissionInformation")!
  const _component_ClinicalDetails = _resolveComponent("ClinicalDetails")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ProcedureSummaryList = _resolveComponent("ProcedureSummaryList")!
  const _component_ReviewStatus = _resolveComponent("ReviewStatus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDetails && _ctx.toggleDetails(...args))),
        class: "view-details text-blue-800 text-sm cursor-pointer"
      }, "(view details)")
    ]),
    _createVNode(_component_SubmissionInformation, {
      historical: _ctx.historical,
      value: _ctx.submissionInformation
    }, null, 8, ["historical", "value"]),
    _createVNode(_component_Modal, {
      active: _ctx.showDetails,
      "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showDetails) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ClinicalDetails, {
          style: {"height":"90vh","width":"80vw"},
          "reference-number": _ctx.adjudication?.clinicalSummary.authorizationId
        }, null, 8, ["reference-number"])
      ]),
      _: 1
    }, 8, ["active"]),
    (_ctx.procedures.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_4,
          _createVNode(_component_ProcedureSummaryList, {
            procedures: _ctx.procedures,
            historical: _ctx.historical
          }, null, 8, ["procedures", "historical"])
        ], 64))
      : _createCommentVNode("", true),
    (!_ctx.historical)
      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 1,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.comments) = $event)),
          rows: "4",
          class: "adjudication-comments p-2 my-4 w-full border-2 rounded-lg",
          placeholder: "Add comments here"
        }, null, 512)), [
          [_vModelText, _ctx.comments]
        ])
      : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.comments), 1)),
    (!_ctx.historical)
      ? (_openBlock(), _createBlock(_component_ReviewStatus, { key: 3 }))
      : _createCommentVNode("", true)
  ]))
}